module.exports = __webpack_public_path__ + "static/media/user.ed52f187.svg";